import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

export default class NotFound extends Component {


  static propTypes = {
    device: PropTypes.instanceOf(Immutable.Map).isRequired
  }

  isAcceptableDevice() {
    const { device } = this.props;
    try {
      // device.getIn 에서 getIn이 undefined로 인식하는 오류가 있어서 우선 아래와 같이 방어
      return ['Android', 'iOS'].includes(device.getIn(['os', 'name']));
    } catch (ignore) {
    }
    return false;
  }

  render() {
    return (
      <div id="kakaoContent" className="cont_plus" role="main">
        <div id="mArticle">
          <h2 id="kakaoBody" className="screen_out">포스트 본문영역</h2>
          <div className="info_err">
            <span className="ico_plus"></span>
            <strong className="tit_err">페이지를 찾을 수 없습니다.</strong>
            {
              this.isAcceptableDevice() ?
                (
                  <p className="desc_err">주소가 잘못되었거나 비공개 또는 삭제된 프로필일 수 있습니다.
                    <br />또는 주소가 정확한지 다시 한번 확인해주세요.
                  </p>
                ) : (
                  <p className="desc_err">비공개 또는 삭제된 프로필일 수 있습니다.
                    <br />또는 주소가 정확한지 다시 한번 확인해주세요.
                  </p>
                )
            }
          </div>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/ErrorContent/NotFound.js